import React, { Component } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
// import 'typeface-roboto';
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
// import TextField from '@material-ui/core/TextField';
import { StepButtons, ReviewTableRow } from "../CommonComponents";
import { Consumer } from "./EWCCContext";
import styles from "../ewccstyle";
import CCAgreement from "./CCAgreement";
// import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
// import TableRow from "@material-ui/core/TableRow";
// import TableCell from "@material-ui/core/TableCell";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
// import Edit from "@material-ui/icons/Edit";
import FormHelperText from "@material-ui/core/FormHelperText";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
// import ReCAPTCHA from "react-google-recaptcha";
import { ewbConfig } from "../../../config";
import { Redirect } from "react-router";

import { Link } from 'react-router-dom';


// class SpecialCaptcha extends Component {
//   constructor(props) {
//     super(props);
//   }

//   handleCaptchaResponseChange = response => {
//     this.props.onChange(this.props.id, response);
//   }

//   render() {
//     return (
//       <ReCAPTCHA
//         ref={(el) => { this.recaptcha = el; }}
//         sitekey="6LezwJoUAAAAADQs9wLQES0REq0-LTmvpz_t4I_g"
//         onChange={this.handleCaptchaResponseChange}
//       />
//     )
//   }

// }

const ReviewDetail = withStyles(styles)(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        redirect: false
      };
    }

    render() {
      const {
        activeStep,
        handleBack,
        classes,
        handleEdit,
        maxStep
      } = this.props;
      if (this.state.redirect) {
        return <Redirect to="/creditcards/thankyou" />;
      }
      return (
        <Consumer>
          {context => (
            <Formik
              initialValues={{
                delivery: context.delivery,
                SOAtoBillingAdd: context.SOAtoBillingAdd,
                consentOther: context.consentOther,
                notARobot: context.notARobot
              }}
              validationSchema={Yup.object().shape({
                delivery: Yup.string().required('This field is required'),
                // notARobot: Yup.string().nullable().required('Please verify if you are human.'),
                // SOAtoBillingAdd: Yup.string().required('This field is required'),
                // consentOther: Yup.string().required('This field is required')
              })}
              onSubmit={(values, actions) => {
                context.updateState("delivery", values.delivery);
                context.updateState("consentOther", values.consentOther);
                context.updateState("SOAtoBillingAdd", values.SOAtoBillingAdd);
                context.updateState("notARobot", values.notARobot);

                //save form data
                var ewbCCFormData = new FormData();
                ewbCCFormData.append("cardType", context.cardType);
                ewbCCFormData.append("deposit", context.deposit);
                ewbCCFormData.append("ewcc", context.ewcc);
                ewbCCFormData.append("cardno", context.cardno);
                ewbCCFormData.append("ewRelConfirm", context.ewRelConfirm);
                ewbCCFormData.append("ewRelName", context.ewRelName);
                ewbCCFormData.append("ewRelRelationship", context.ewRelRelationship);
                ewbCCFormData.append("ewPos", context.ewPos);
                ewbCCFormData.append("ewPEP", context.ewPEP);
                ewbCCFormData.append("ewPEPRel", context.ewPEPRel);
                ewbCCFormData.append("ewPEPRelName", context.ewPEPRelName);
                ewbCCFormData.append("ewPEPRelRelationship", context.ewPEPRelRelationship);
                // ewbCCFormData.append("reference", context.reference.value);
                // ewbCCFormData.append("refothers", context.refothers);
                ewbCCFormData.append("firstName", context.firstName);
                ewbCCFormData.append("middleName", context.middleName);
                ewbCCFormData.append("lastName", context.lastName);
                ewbCCFormData.append("cardName", context.cardName);
                ewbCCFormData.append("birthDate", context.birthDate);
                ewbCCFormData.append("birthPlace", context.birthPlace);
                ewbCCFormData.append("momName", context.momName);
                ewbCCFormData.append("momName1", context.momName1);
                ewbCCFormData.append("momName2", context.momName2);
                ewbCCFormData.append("sex", context.sex);
                ewbCCFormData.append("civilStatus", context.civilStatus);
                ewbCCFormData.append(
                  "numberDependents",
                  context.numberDependents
                );
                ewbCCFormData.append("numberCar", context.numberCar);
                ewbCCFormData.append("educ", context.educ);
                ewbCCFormData.append(
                  "citizenship1",
                  context.citizenship1
                );
                ewbCCFormData.append("citizenship", context.citizenship);
                ewbCCFormData.append("acr", context.acr);
                ewbCCFormData.append("tinNo", context.tinNo);
                ewbCCFormData.append("sssNo", context.sssNo);
                ewbCCFormData.append("homeAddress", context.homeAddress);
                ewbCCFormData.append("zipCode", context.zipCode);
                ewbCCFormData.append(
                  "chkPermAddSameWithHomeAdd",
                  context.chkPermAddSameWithHomeAdd
                );
                ewbCCFormData.append(
                  "permanentAddress",
                  context.permanentAddress
                );
                ewbCCFormData.append("zipCode2", context.zipCode2);
                ewbCCFormData.append("homeOwner", context.homeOwner);
                ewbCCFormData.append("yearStay", context.yearStay);
                ewbCCFormData.append("homePhone", `(${context.homeAreaCode.trim()})+${context.homePhone}`);
                ewbCCFormData.append("mobilePhone", context.mobilePhone);
                ewbCCFormData.append("emailAddress", context.emailAddress);
                ewbCCFormData.append(
                  "emailAddressAlt",
                  context.emailAddressAlt
                );
                ewbCCFormData.append("socMed", context.socMed);
                ewbCCFormData.append("fundSrc", context.fundSrc);
                ewbCCFormData.append("fundSrc1", context.fundSrc1);
                ewbCCFormData.append("workType", context.workType);
                ewbCCFormData.append("employment1", context.employment1);
                ewbCCFormData.append("workYear", context.workYear);
                ewbCCFormData.append("workPos", context.workPos);
                ewbCCFormData.append("workPos1", context.workPos1);
                ewbCCFormData.append("workPos2", context.workPos2);
                ewbCCFormData.append("workNature", context.workNature);
                ewbCCFormData.append("businessName", context.businessName);
                ewbCCFormData.append("businessDept", context.businessDept);
                ewbCCFormData.append(
                  "businessAddress",
                  context.businessAddress
                );
                ewbCCFormData.append("businessZip", context.businessZip);
                ewbCCFormData.append("businessPhone", context.businessPhone);
                ewbCCFormData.append("businessIncome", context.businessIncome);
                ewbCCFormData.append("cardIssuer1", context.cardIssuer1);
                ewbCCFormData.append("cardNumber1", context.cardNumber1);
                ewbCCFormData.append("memberSince1", context.memberSince1);
                ewbCCFormData.append("creditLimit1", context.creditLimit1);
                ewbCCFormData.append("cardIssuer2", context.cardIssuer2);
                ewbCCFormData.append("cardNumber2", context.cardNumber2);
                ewbCCFormData.append("memberSince2", context.memberSince2);
                ewbCCFormData.append("creditLimit2", context.creditLimit2);
                ewbCCFormData.append("cardIssuer3", context.cardIssuer3);
                ewbCCFormData.append("cardNumber3", context.cardNumber3);
                ewbCCFormData.append("memberSince3", context.memberSince3);
                ewbCCFormData.append("creditLimit3", context.creditLimit3);
                ewbCCFormData.append("spouseName", context.spouseName);
                ewbCCFormData.append("spouseBusiness", context.spouseBusiness);
                ewbCCFormData.append("spousePosition", context.spousePosition);
                ewbCCFormData.append("spouseDept", context.spouseDept);
                ewbCCFormData.append("spouseAddress", context.spouseAddress);
                ewbCCFormData.append("spouseZip", context.spouseZip);
                ewbCCFormData.append("spousePhone", `(${context.spouseAreaCode.trim()})+${context.spousePhone}`);
                // ewbCCFormData.append("spousePhone", context.spousePhone);
                ewbCCFormData.append("spouseCP", context.spouseCP);
                ewbCCFormData.append("spouseIncome", context.spouseIncome);
                ewbCCFormData.append("friendName", context.friendName);
                ewbCCFormData.append("friendBusiness", context.friendBusiness);
                ewbCCFormData.append("friendPosition", context.friendPosition);
                ewbCCFormData.append("friendDept", context.friendDept);
                ewbCCFormData.append("friendPhone", context.friendPhone);
                ewbCCFormData.append("delivery", context.delivery);
                ewbCCFormData.append("SOAtoBillingAdd",context.SOAtoBillingAdd);
                ewbCCFormData.append("notARobot",context.notARobot);

                // fetch('http://localhost/drupal/web/ewbcc/submit', {
                // fetch('http://beta.tribalddbph.com/ewmock/save.php', {
                fetch(ewbConfig.ewbCCFormAPI, {
                  method: "POST",
                  body: ewbCCFormData
                })
                  .then(response => {
                    if (response.ok) {
                      // window.dataLayer.push({
                      //     'ewformeventcat': 'EW Time Deposit Application Form Submit',
                      //     'ewformeventaction': 'Details successfully saved!',
                      //     'event': 'ewformevent'
                      //   });

                      this.props.handleSubmit(true);
                      actions.setSubmitting(false);
                      context.resetForm();
                      this.setState({
                        redirect: true
                      });
                      // browserHistory.push('/thank-you');
                      // <Redirect to="/thank-you" />
                    } else {
                      alert("Unable to connect to server! Please try again.");
                      actions.setSubmitting(false);
                    }
                  })
                  .catch(err => {
                    // console.log(err);
                    // this.setState({
                    //   erroralert: true,
                    //   btnDisabled: false
                    // });

                    // window.dataLayer.push({
                    // 	'ewformeventcat': 'EW Time Deposit Application Form Submit',
                    // 	'ewformeventaction': 'API Error!!!',
                    // 	'event': 'ewformevent'
                    // });

                    alert("Our servers are busy now! Please try again.");
                    actions.setSubmitting(false);
                  });
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                isSubmitting
              }) => (
                <>
                  <Table className={classes.table}>
                    <TableBody>
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="7"
                        headerText="Credit Card of choice"
                        bodyText={context.cardType.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="Are you an existing EastWest Client?"
                        bodyText={context.deposit}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="Are you an existing Principal EastWest Credit
                            Cardholder?"
                        bodyText={context.ewcc}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="EastWest Credit Card Number"
                        bodyText={context.cardno}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="Are you a Director, Officer, or Shareholder of EastWest Bank? "
                        bodyText={context.ewPos}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="Are you a relative of a Director, Officer, or Shareholder of EastWest Bank, EastWest Rural Bank or any subsidiary and/or affiliate of the Filinvest Group of Companies?"
                        bodyText={context.ewRelConfirm}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="Name (First, Middle, Last)"
                        bodyText={context.ewRelName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="Relationship"
                        bodyText={context.ewRelRelationship}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="Are you a Politically Exposed Person (PEP)? "
                        bodyText={context.ewPEP}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="Are you a relative of a Politically Exposed Person (PEP)?"
                        bodyText={context.ewPEPRel}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="Name (First, Middle, Last)"
                        bodyText={context.ewPEPRelName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="6"
                        headerText="Relationship"
                        bodyText={context.ewPEPRelRelationship}
                      />
                      {/* <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Where did you hear about EastWest Credit Card?"
                        bodyText={context.reference.label}
                      />
                      {context.reference === "OTH" ? (
                        <ReviewTableRow
                          handleEdit={handleEdit}
                          value="5"
                          headerText="Others"
                          bodyText={context.refothers}
                        />
                      ) : (
                        ""
                      )} */}
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="First name"
                        bodyText={context.firstName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Middle Name"
                        bodyText={context.middleName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Last Name"
                        bodyText={context.lastName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Name to appear on Card"
                        bodyText={context.cardName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Birthdate"
                        bodyText={context.birthDate}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Place of Birth"
                        bodyText={context.birthPlace}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Mother's First Name"
                        bodyText={context.momName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Mother's Middle Name"
                        bodyText={context.momName1}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Mother's Last Name"
                        bodyText={context.momName2}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Gender"
                        bodyText={context.sex.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Civil Status"
                        bodyText= {context.civilStatus.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="No. of Dependents"
                        bodyText={context.numberDependents}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="No. of Cars Owned"
                        bodyText={context.numberCar}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Education"
                        bodyText={context.educ.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Citizenship/Nationality"
                        bodyText={context.citizenship1.label}
                      />
                      {context.citizenship1 === "Others" ? (
                        <ReviewTableRow
                          handleEdit={handleEdit}
                          value="5"
                          headerText="Others"
                          bodyText={context.citizenship}
                        />
                      ) : (
                        ""
                      )}

                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="ACR No."
                        bodyText={context.acr}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Tax Identification Number (TIN)"
                        bodyText={context.tinNo}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="SSS/GSIS No."
                        bodyText={context.sssNo}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Present/Home Address"
                        bodyText={context.homeAddress}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Zip Code"
                        bodyText={context.zipCode}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Same as Present / Home Adress"
                        // bodyText={context.chkPermAddSameWithHomeAdd}
                        bodyText={context.chkPermAddSameWithHomeAdd === "" ? "No" : "Yes"}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Permanent Address"
                        bodyText={context.permanentAddress}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Zip Code"
                        bodyText={context.zipCode2}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Home Ownership"
                        bodyText={context.homeOwner.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Years of Stay"
                        bodyText={context.yearStay}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Area Code"
                        bodyText={context.homeAreaCode}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Home Phone Number"
                        bodyText={context.homePhone}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Mobile Phone Number"
                        bodyText={context.mobilePhone}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Primary E-mail Address"
                        bodyText={context.emailAddress}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Alternate E-mail Address"
                        bodyText={context.emailAddressAlt}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="5"
                        headerText="Social Media Accounts "
                        bodyText={context.socMed}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Source of Wealth/Income "
                        bodyText={context.fundSrc.label}
                      />
                      {context.fundSrc === "OTHERS" ? (
                        <ReviewTableRow
                          handleEdit={handleEdit}
                          value="4"
                          headerText="Source of Wealth/Income  - Other"
                          bodyText={context.fundSrc1}
                        />
                      ) : (
                        ""
                      )}
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Employment"
                        bodyText={context.workType.label}
                      />
                      {context.workType === "OTHERS" ? (
                        <ReviewTableRow
                          handleEdit={handleEdit}
                          value="4"
                          headerText="Employment - Other"
                          bodyText={context.employment1}
                        />
                      ) : (
                        ""
                      )}
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Years with Present Employer/Business"
                        bodyText={context.workYear}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Position/Rank"
                        bodyText={context.workPos.label}
                      />
                      {context.workPos === "OTHERS" ? (
                        <ReviewTableRow
                          handleEdit={handleEdit}
                          value="4"
                          headerText="Position/Rank - Other"
                          bodyText={context.workPos2}
                        />
                      ) : (
                        ""
                      )}
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Job Title/Occupation"
                        bodyText={context.workPos2.label}
                      />

                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Nature of Present Business"
                        bodyText={context.workNature.label}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Company/Business Name"
                        bodyText={context.businessName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Department"
                        bodyText={context.businessDept}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Company/Business Address"
                        bodyText={context.businessAddress}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Zip Code"
                        bodyText={context.businessZip}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Company/Business Phone Number"
                        bodyText={context.businessPhone}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="4"
                        headerText="Gross Annual Income"
                        bodyText={context.businessIncome}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Card Issuer"
                        bodyText={context.cardIssuer1}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Card Number"
                        bodyText={context.cardNumber1}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Member Since"
                        bodyText={context.memberSince1}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Credit Limit"
                        bodyText={context.creditLimit1}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Card Issuer"
                        bodyText={context.cardIssuer2}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Card Number"
                        bodyText={context.cardNumber2}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Member Since"
                        bodyText={context.memberSince2}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Credit Limit"
                        bodyText={context.creditLimit2}
                      />
                      {/* <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Card Issuer"
                        bodyText={context.cardIssuer3}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Card Number"
                        bodyText={context.cardNumber3}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Member Since"
                        bodyText={context.memberSince3}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="3"
                        headerText="Credit Limit"
                        bodyText={context.creditLimit3}
                      /> */}
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Name of Spouse"
                        bodyText={context.spouseName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Company/Business Name"
                        bodyText={context.spouseBusiness}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Position"
                        bodyText={context.spousePosition}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Department"
                        bodyText={context.spouseDept}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Company/Business Address"
                        bodyText={context.spouseAddress}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Zip Code"
                        bodyText={context.spouseZip}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Area Code"
                        bodyText={context.spouseAreaCode}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Company/Business Phone Number"
                        bodyText={context.spousePhone}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Mobile Phone Number"
                        bodyText={context.spouseCP}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="2"
                        headerText="Gross Annual Income"
                        bodyText={context.spouseIncome}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Full Name"
                        bodyText={context.friendName}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Company/Business Name"
                        bodyText={context.friendBusiness}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Position"
                        bodyText={context.friendPosition}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Department"
                        bodyText={context.friendDept}
                      />
                      <ReviewTableRow
                        handleEdit={handleEdit}
                        value="1"
                        headerText="Contact No."
                        bodyText={context.friendPhone}
                      />
                    </TableBody>
                  </Table>
                  <br />
                  <Typography variant="body1" gutterBottom>
                    <big>My Billing Preference</big>
                  </Typography>
                  <FormControl
									  required
                    fullWidth
                    error={errors.delivery && touched.delivery ? true : false}
                  >
                    <FormLabel component="legend">
                      Send my card to my:
                    </FormLabel>
                    <RadioGroup
                      aria-label=""
                      name="delivery"
                      className={classes.group}
                      value={values.delivery}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <FormControlLabel
                        value="H"
                        control={<Radio />}
                        label="Present/Home Address"
                      />
                      <FormControlLabel
                        value="O"
                        control={<Radio />}
                        label="Company/Business Address"
                      />
                    </RadioGroup>

                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.radioError,
                        error: classes.error
                      }}
                      component="p"
                    >
                      {errors.delivery && touched.delivery && (
                        <>{errors.delivery}</>
                      )}
                    </FormHelperText>
                  </FormControl>
                  <br />
                  <Typography variant="body1" gutterBottom>
                    <big>My Statement of Account</big>
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Go green, Go paperless!
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                  Safe, on-time and secured. You will automatically receive your password-protected electronic Statement of Account (e-SOA) monthly to your primary registered e-mail address on record. Conveniently view and download within five (5) banking days from your statement cut-off date. You will even be notified through SMS to make sure you don’t miss it. To know more, refer to the <Link to="/supportandsecurity/termsandconditions/electronicstatementofaccount">Terms and Conditions Governing EastWest Credit Cards e-SOA Facility. </Link>
                  <br/><br/>
                  You can also conveniently access your e-SOA anytime, through EastWest Online, EastWest Mobile App, and EastWest System Tech Assistant (ESTA) chatbot via <a rel="noopener noreferrer" target="_blank" href="https://m.me/EastWestBanker">m.me/EWBESTA. </a>
                  <br/><br/>
                  </Typography>


                  <FormControl
                    fullWidth
                  >
                    <FormLabel component="legend">
                      Should you prefer to receive your SOA in your billing
                      address, please tick this box:
                    </FormLabel>

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.SOAtoBillingAdd}
                          onChange={handleChange}
                          value="SOAtoBillingAdd"
                          id="SOAtoBillingAdd"
                          name="SOAtoBillingAdd"
                        />
                      }
                      label="Send my SOA to my billing address."
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.radioError,
                        error: classes.error
                      }}
                      component="p"
                    >
                      {errors.SOAtoBillingAdd && touched.SOAtoBillingAdd && (
                        <>{errors.SOAtoBillingAdd}</>
                      )}
                    </FormHelperText>
                  </FormControl>
                  <article className={classes.termsContainer}>
                    <CCAgreement />
                  </article>

                  <FormControl
                    fullWidth
                    error={
                      errors.radioAgree && touched.radioAgree ? true : false
                    }
                  >
                    <FormLabel component="legend" gutterBottom>
                      <span className={classes.bold}>
                        Consent to Apply for Other Bank Product{" "}
                      </span>
                      (Should you opt otherwise, please un-tick the box below.)
                    </FormLabel>

                    <FormControlLabel
                      style={{ alignItems: "flex-start", marginTop: "16px" }}
                      control={
                        <Checkbox
                          style={{
                            alignItems: "flex-start",
                            padding: "0 12px"
                          }}
                          checked={values.consentOther}
                          onChange={handleChange}
                          value="consentOther"
                          id="consentOther"
                          name="consentOther"
                        />
                      }
                      label="I/we agree that this Application Form may also serve as my/our application for other products of EastWest, such as, but not limited to, auto loan, home loan, personal loan, EEL, among others, as I/we may subsequently request from EastWest or if I/we are deemed qualified by EastWest. I/We undertake to submit additional documents as may be required by EastWest for the processing of my/our application. I/We understand that the availment of the other products of EastWest is my/our option but the approval shall be subject to credit evaluation and sole discretion of EastWest. I/We understand that EastWest can rely on the authority/ies given under this section unless I/we explicitly revoke the same."
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.radioError,
                        error: classes.error
                      }}
                      component="p"
                    >
                      {errors.consentOther && touched.consentOther && (
                        <>{errors.consentOther}</>
                      )}
                    </FormHelperText>
                  </FormControl>

                  <br />
                  <br />

                  {/* <FormControl
                    required
                      // className={}
                      fullWidth
                      error={errors.notARobot && touched.notARobot ? true : false}
                  >

                    <SpecialCaptcha
                      id="notARobot"
                      value={values.notARobot}
                      onChange={setFieldValue}
                    />

                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.radioError,
                        error: classes.error
                      }}
                      component="p"
                    >
                      {errors.notARobot && touched.notARobot && (
                        <>{errors.notARobot}</>
                      )}
                    </FormHelperText>

                  </FormControl> */}

                  <br />

                  <StepButtons
                    isSubmitting={isSubmitting}
                    activestep={activeStep}
                    maxstep={maxStep}
                    handleBack={handleBack}
                    handleNext={handleSubmit}
                  />
                </>
              )}
            </Formik>
          )}
        </Consumer>
      );
    }
  }
);

export default ReviewDetail;
